import {en_US} from "./en_US";

export const en = en_US;